import React from "react";
import { usePermissions } from "../../context/PermissionProvider";

/**
 * Component to conditionally render children based on permissions
 * @param {string} module - The module name (e.g., "employee", "taskManagement")
 * @param {string} action - The action required (e.g., "view", "add", "edit", "delete")
 * @param {React.ReactNode} children - The content to render if permission is granted
 * @param {React.ReactNode} fallback - Optional fallback content if permission is denied
 */
const PermissionGate = ({ module, action = "view", children, fallback = null }) => {
  const { hasPermission, loading } = usePermissions();

  if (loading) {
    return null; // Or return a skeleton/loading indicator if needed
  }

  if (!hasPermission(module, action)) {
    return fallback;
  }

  return <>{children}</>;
};

export default PermissionGate;
